import { Menu } from '@headlessui/react';
import { UserIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { useAuth } from 'lib/auth';
import React from 'react';
import { Clock, Cpu, CreditCard, Heart, LogOut, Settings, User } from 'react-feather';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export const UserNavigation = () => {
  const { user, logout } = useAuth();

  const userNavigation = [
    { name: 'Account', icon: <User className="h-4" />, to: '/app/my-account' },
    { name: 'Billing', icon: <CreditCard className="h-4" />, to: '/app/billing' },
    { name: 'Integrations', icon: <Cpu className="h-4" />, to: '/app/integrations' },
    { name: 'Features & Updates', icon: <Clock className="h-4" />, to: '/app/features-updates' },
    { name: 'Help & Support', icon: <Heart className="h-4" />, to: '/app/support' },

    {
      name: 'Sign out',
      icon: <LogOut className="h-4 text-red-500" />,
      to: '',
      onClick: () => logout(),
    },
  ];

  return (
    <Menu as="div" className="relative z-[999]">
      {({ open }) => (
        <>
          {/* Button Trigger */}
          <Menu.Button className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-gray-900 text-gray-100 hover:bg-gray-800 transition active:scale-[0.98]">
            <UserIcon className="h-4 w-4" />
            <span className="hidden sm:block text-sm">{user.email}</span>
          </Menu.Button>

          {/* Dropdown Animation */}
          <AnimatePresence>
            {open && (
              <Menu.Items
                static
                as={motion.div}
                initial={{ opacity: 0, y: -6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.18 }}
                className="absolute right-0 mt-3 w-52 rounded-xl overflow-hidden bg-white shadow-xl border border-gray-100 focus:outline-none"
              >
                {userNavigation.map((item) => (
                  <Menu.Item key={item.name}>
                    {({ active }) => (
                      <Link
                        to={item.to}
                        onClick={item.onClick}
                        className={clsx(
                          'flex items-center gap-3 px-4 py-2 text-sm transition',
                          active ? 'bg-gray-100' : 'bg-white',
                          item.name === 'Sign out' && 'font-medium text-red-600 hover:text-red-700'
                        )}
                      >
                        {item.icon}
                        <span>{item.name}</span>
                      </Link>
                    )}
                  </Menu.Item>
                ))}
              </Menu.Items>
            )}
          </AnimatePresence>
        </>
      )}
    </Menu>
  );
};
